/* eslint-disable max-len */
import { title } from 'process';

import * as yup from 'yup';

export const initialFlowState = {
  isLoading: true,
  isSuccess: '',
  largeImageMessage: '',
  isImageViewOpen: false,
  isButtonLoading: false,
  imageSrcForAction: '',
  isDeleteModalOpen: false,
}

export const initialFormState = {
  name: '',
  visible: true,
  uploadedFileList: null
}

const imageListSchemaOptional = yup.mixed()
  .test(
    'is-files-length',
    'You can upload maximum 5 pictures',
    (value) => Object.keys(value || {}).length <= 5
  )
  .nullable()

export const fileSchema = yup
  .mixed()
  .test('required', 'File is required', (value: any, bbbb: any) => {
    return value && value?.length > 0 || bbbb?.from?.[0]?.value?.images?.length > 0;
  })

export const createMarkSchema = yup.object().shape({
  name: yup.string().required('Name is required.').max(250, 'Name must contain at least maximum length 250'),
  images: imageListSchemaOptional,
  uploadedFileList: fileSchema,
  visible: yup.boolean().required(),
});
